import { AxiosClient } from "@/app/shared/services";
import store from "@/app/app-state";

const state = {
  auth: {
    phone: null,
  },
};

const getters = {
  PHONE: (state) => state.auth.phone,
};

const mutations = {
  SET_PHONE: (state, payload) => {
    state.auth.phone = payload;
  },
};

const actions = {
  DROP_PERSONAL_DATA: (context) => {
    return new Promise((resolve, reject) => {
      resolve();
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
